import { useCallback } from 'react';

interface UseLoadMoreOnScrollOptions {
  hasMore: boolean;
  loadingMore: boolean;
  loading: boolean;
  loadMore: () => void;
}

const useLoadMoreOnScroll = ({ hasMore, loadingMore, loading, loadMore }: UseLoadMoreOnScrollOptions) =>
  useCallback(
    (event: React.UIEvent<HTMLDivElement>) => {
      const target = event.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;

      // Load more data when user scrolls to 80% of the content
      const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;
      if (scrollPercentage > 0.8 && hasMore && !loadingMore && !loading) {
        loadMore();
      }
    },
    [hasMore, loadingMore, loading, loadMore]
  );

export default useLoadMoreOnScroll;
